module.exports = __webpack_public_path__ + "static/media/pan-logo.d7d44116.png";